var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersona3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "595px",
    height: "842px",
    viewBox: "0 0 595 842",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "persona3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.653299248 0.278075188 26.4581489 0.278075188 26.4581489 10.8278226 0.653299248 10.8278226"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 0.713545865 16.3611752 0.713545865 16.3611752 15.7869669 0 15.7869669"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-5",
    points: "0.458627068 0.302785714 35.9170556 0.302785714 35.9170556 2.70676692 0.458627068 2.70676692"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-7",
    points: "0.076437594 0.302785714 35.5301594 0.302785714 35.5301594 2.70676692 0.076437594 2.70676692"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "persona3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 595,
    height: 842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,39 L437,39 C456.882251,39 473,55.117749 473,75 L473,75 C473,94.882251 456.882251,111 437,111 L0,111 L0,39 Z",
    id: "Rectangle",
    fill: "#FFFAB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,131 L501,131 C520.882251,131 537,147.117749 537,167 L537,167 C537,186.882251 520.882251,203 501,203 L0,203 L0,131 Z",
    id: "Rectangle-Copy",
    fill: "#FFFAB0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-67",
    transform: "translate(55.000000, 23.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.7817346,97.7620429 C38.5834865,98.0279752 35.947697,98.4445241 33.9096669,98.8728398 C33.9849752,98.9646218 34.0461632,99.0564038 34.1285316,99.1528925 C37.9786669,103.925554 39.5483737,103.836126 39.9743361,103.661975 C40.0143436,103.643148 40.0449376,103.626674 40.066118,103.617261 C40.0708248,103.607847 40.0802383,103.607847 40.0825917,103.600787 L40.0755316,103.607847 L40.1225992,103.586667 L41.3722459,107.455629 L47.7193211,107.455629 L47.7193211,97.9079526 L54.6194414,97.9079526 L54.6194414,97.8538248 L54.6194414,90.5159752 C52.7437947,90.9395842 50.7810729,91.1749226 48.7148023,91.1749226 C48.498291,91.1749226 48.2817797,91.1537421 48.062915,91.146682 L48.062915,27.7865391 C48.0064338,27.798306 47.9546594,27.8124263 47.8934714,27.8265466 C47.8934714,27.8265466 34.3732835,32.2626744 23.1264639,28.7396594 C20.7118925,32.2862083 18.8268323,36.8870729 17.9560805,42.8599602 L13.1222308,46.5571256 C13.1387045,46.6842083 13.1457647,46.8089376 13.159885,46.9313135 C13.1316444,46.9383737 13.0728098,46.9454338 12.9904414,46.9666143 C12.0914489,47.1690053 8.20836617,48.3033361 8.22013308,52.8877271 C8.22013308,53.8667346 8.39899023,55.0034188 8.82259925,56.3213135 C11.4889827,64.6240504 16.9558925,63.9227421 16.9558925,63.9227421 C21.1190278,75.3342985 28.5110053,85.813915 39.1788925,89.6334564 C40.0284639,89.9393962 40.8921556,90.2170955 41.7817346,90.4312534 L41.7817346,97.7620429 Z",
    id: "Fill-1",
    fill: "#C8A985"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4001444,46.9251947 C83.4001444,46.9251947 83.4142647,46.9322549 83.4448586,46.939315 L83.4966331,46.7063301 C83.4966331,46.7063301 83.5084,46.6145481 83.5319338,46.4498113 L77.8320391,42.5949692 C75.4786556,26.3919241 65.7003474,20.2825406 57.9177083,17.9950519 C56.7904376,21.5651346 52.6225955,26.7637586 48.0617383,27.7851271 L48.0617383,91.1476233 C48.280603,91.1546835 48.4971143,91.1758639 48.7159789,91.1758639 C50.7822496,91.1758639 52.7449714,90.9381722 54.620618,90.5145632 C55.4678361,90.3215857 56.2962271,90.1027211 57.105791,89.8297286 C68.0866782,86.1749241 75.6339789,75.5305707 79.8394752,63.9354504 C79.6982722,63.9307436 79.6159038,63.9236835 79.6159038,63.9236835 L83.4001444,46.9251947 Z",
    id: "Fill-3",
    fill: "#D2BA9C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(47.067669, 0.075308)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.825096241,4.53958195 L0.825096241,4.48545414 C0.825096241,4.48545414 0.94041203,4.49251429 1.14515639,4.51369474 C1.35460752,4.49251429 1.46756992,4.48545414 1.46756992,4.48545414 L1.46756992,4.53958195 C4.26809624,4.79139398 15.7879083,6.08810827 26.4581489,10.8278226 C21.1418556,5.46916842 13.0320962,1.11305564 0.653299248,0.277604511 L0.653299248,4.55840902 C0.714487218,4.55134887 0.770968421,4.54193534 0.825096241,4.53958195",
    id: "Fill-5",
    fill: "#D1833F",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M47.7202624,1.2410797 C34.6848714,2.34246316 26.3868414,7.03275639 21.0964353,12.6314556 C32.0349617,7.30574887 44.4725932,5.83017744 47.7202624,5.51953083 L47.7202624,1.2410797 Z",
    id: "Fill-8",
    fill: "#8B572A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9895,46.9666143 L12.9377256,46.7077421 C12.9377256,46.7077421 12.1752293,43.1000053 12.6882669,38.2708624 C13.0930489,34.5078023 14.272094,30.0010729 17.199703,25.8685316 C15.1357857,24.416494 13.2930865,22.5243737 11.8339887,20.0721481 C11.8339887,20.0721481 20.6944774,21.8442459 23.1325827,15.8642985 C25.570688,9.88199774 38.544891,2.52296767 47.8925301,13.4050128 L47.8925301,5.50470451 C47.8384023,5.51176466 47.7819211,5.51647143 47.7207331,5.5211782 C44.4730639,5.83182481 32.0354323,7.30504286 21.096906,12.6307496 C9.79831203,18.1282534 0.10237218,27.748885 3.85837218,44.4367271 C3.85837218,44.4367271 4.67499624,48.9058023 8.22154511,52.8877271 C8.2097782,48.3033361 12.0905075,47.1690053 12.9895,46.9666143",
    id: "Fill-10",
    fill: "#DDDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5361805,4.55958571 C48.5361805,4.55958571 48.4208647,4.56899925 48.2114135,4.5901797 C48.3031955,4.59723985 48.4114511,4.6043 48.5361805,4.61371353 L48.5361805,4.55958571 Z",
    id: "Fill-12",
    fill: "#DDDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2121195,5.47905263 C48.0073752,5.46257895 47.8920594,5.45081203 47.8920594,5.45081203 L47.8920594,5.50493985 L47.8920594,13.4052481 C47.8920594,13.4052481 51.2879917,13.3040526 54.2862023,13.8100301 C86.2992774,17.4224737 83.8894128,43.6226917 83.5316985,46.4491053 C83.5081647,46.6138421 83.4963977,46.7079774 83.4963977,46.7079774 L83.4446233,46.938609 C83.9270669,47.0256842 88.2643526,47.9623308 88.3561346,52.7232256 C91.7756008,48.7789549 92.5733977,44.4369624 92.5733977,44.4369624 C96.5247286,26.8618947 85.5697286,17.1330075 73.525112,11.7931805 C62.8572248,7.05346617 51.3350594,5.76145865 48.5368865,5.50493985 C48.4121571,5.49317293 48.3039015,5.48611278 48.2121195,5.47905263",
    id: "Fill-14",
    fill: "#EDEDEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4439173,46.9390797 C83.4133233,46.9320195 83.399203,46.9249594 83.399203,46.9249594 L79.6149624,63.9234481 C79.6149624,63.9234481 79.6973308,63.9305083 79.8408872,63.935215 C80.8881429,63.9611023 85.4019323,63.6363353 87.7553158,56.3196662 C88.2024586,54.9264632 88.3719023,53.7403579 88.3554286,52.7236962 C88.2636466,47.9628015 83.9263609,47.0261549 83.4439173,46.9390797",
    id: "Fill-16",
    fill: "#C8A985"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1316414,15.8647692 C20.6958895,21.8447165 11.8330474,20.0726188 11.8330474,20.0726188 C13.2921451,22.5248444 15.1371977,24.4169647 17.1987617,25.8690023 C14.2711526,30.0015436 13.0921075,34.5082729 12.6896789,38.2713331 C12.3225511,43.2016714 12.9367842,46.7058594 12.9367842,46.7058594 L13.1227015,46.5575962 L17.9565511,42.8604308 C18.827303,36.8875436 20.7123632,32.2866789 23.1269346,28.7401301 C34.3714008,32.2631451 47.8915887,27.8270173 47.8915887,27.8270173 L47.8915887,13.4054835 C38.546303,2.52343835 25.5697466,9.88246842 23.1316414,15.8647692",
    id: "Fill-18",
    fill: "#54422D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9174729,17.9950519 C65.7024654,20.2825406 75.4784203,26.3919241 77.8318038,42.5949692 L83.5316985,46.4498113 C83.8894128,43.6233977 86.2992774,17.4231797 54.2862023,13.8107361 C51.2879917,13.3047586 47.8920594,13.4059541 47.8920594,13.4059541 L47.8920594,27.827488 C47.9556008,27.8133677 48.0050218,27.7992474 48.0638564,27.7851271 C52.6223602,26.7637586 56.7902023,21.5651346 57.9174729,17.9950519",
    id: "Fill-20",
    fill: "#5D4C37"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(0.000000, 183.992602)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.18586992,0.713545865 C0.444554135,1.73491429 -0.000235338346,2.9986812 -0.000235338346,4.36364361 L-0.000235338346,9.63522256 C-0.000235338346,13.0311549 2.70144887,15.7869669 6.03148647,15.7869669 C9.35681729,15.7869669 12.0514414,13.0311549 12.0514414,9.63522256 L12.0514414,5.87451579 L12.8233511,7.93137293 C13.1622383,8.88213985 14.2024338,9.37399699 15.1532008,9.03746316 C16.0969075,8.70328271 16.5934714,7.66073383 16.2545842,6.71467368 L15.2473361,4.00592932 C15.2143887,3.93062105 15.1720278,3.86001955 15.1367271,3.78706466 C15.1367271,3.78706466 14.3930579,2.19147068 12.7833436,0.713545865 L6.33742632,0.713545865 L1.18586992,0.713545865 Z",
    id: "Fill-22",
    fill: "#C8A985",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M95.2247195,184.706147 L90.0708098,184.706147 L83.6225391,184.706147 C82.0175316,186.184072 81.2691556,187.779666 81.2691556,187.779666 L81.271509,187.779666 C81.2385617,187.852621 81.1962008,187.923223 81.1679602,187.998531 L80.1536519,190.707275 C79.817118,191.653335 80.313682,192.695884 81.2597421,193.030065 C82.210509,193.366598 83.241291,192.874741 83.5919451,191.923974 L84.3591481,189.867117 L84.3591481,193.627824 C84.3591481,197.023756 87.0584789,199.779568 90.3838098,199.779568 C93.7067872,199.779568 96.406118,197.023756 96.406118,193.627824 L96.406118,188.356245 C96.406118,186.991283 95.963682,185.727516 95.2247195,184.706147",
    id: "Fill-25",
    fill: "#D2BA9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3838293,291.015068 C26.1604459,290.859744 26.9441226,290.949173 27.7089722,291.502218 C28.4291075,292.012902 28.7868218,292.674203 28.8927241,293.387278 C29.0268669,294.319218 28.7091602,295.338233 28.0525662,296.192511 C28.0102053,296.251346 28.0007917,296.333714 28.0102053,296.425496 C28.0102053,296.42785 28.3632128,297.416271 29.2386714,298.122286 C30.5306789,299.018925 32.4039722,299.143654 33.8795436,299.160128 C34.6844008,299.164835 35.4845511,299.12012 36.2847015,299.044812 C36.8989346,298.988331 37.5084609,298.873015 38.1062203,298.760053 C38.5910173,298.663564 38.9675586,298.48706 39.4311752,298.329383 C39.6406263,298.261135 39.9371526,298.183474 40.2242654,298.15994 C40.0995361,297.748098 39.9653932,297.333902 39.8124233,296.92912 L39.8124233,287.160226 L25.3838293,287.160226 L25.3838293,291.015068 Z",
    id: "Fill-27",
    fill: "#C8A985"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0050662,296.928414 C56.8544496,297.340256 56.7179534,297.749745 56.6002842,298.159234 C56.9274045,298.152174 57.2945323,298.251016 57.5486977,298.331031 C58.0123143,298.486354 58.3935624,298.662858 58.8807128,298.759347 C59.4761188,298.872309 60.0832917,298.987625 60.6951714,299.044106 C61.4953218,299.121768 62.3001789,299.164129 63.1050361,299.159422 C64.8088857,299.135888 67.0375398,298.987625 68.2942466,297.653256 C68.4731038,297.460279 69.1814722,296.518926 68.9320135,296.194159 C68.2777729,295.346941 67.9577128,294.344399 68.0871489,293.41952 C68.185991,292.694677 68.5413519,292.01455 69.2685474,291.501512 C69.9816226,290.988474 70.7111714,290.870805 71.4383669,290.986121 L71.4383669,286.272294 L57.0050662,286.272294 L57.0050662,296.928414 Z",
    id: "Fill-29",
    fill: "#D2BA9C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-33",
    transform: "translate(55.127820, 306.015158)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-32"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-31",
    fill: "#417505",
    mask: "url(#mask-6)",
    points: "0.778687218 0.738161654 0.778687218 0.302785714 0.458627068 0.302785714 0.458627068 2.70794361 35.9170556 2.70794361 35.9170556 0.302785714 35.9170556 0.738161654"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M76.3976519,300.488377 L66.4781406,298.770408 C68.4055617,298.429167 69.0927496,296.424084 69.0927496,296.424084 C71.1307797,297.252475 76.3976519,300.488377 76.3976519,300.488377 M69.2692534,291.503159 C68.5420579,292.013844 68.186697,292.693971 68.0878549,293.418814 C67.9584188,294.346047 68.2784789,295.346235 68.9327195,296.193453 C69.1821782,296.51822 68.4738098,297.459573 68.2949526,297.65255 C67.0358925,298.986919 64.8095917,299.137535 63.1057421,299.161069 C62.300885,299.165776 61.4960278,299.121062 60.6958774,299.045753 C60.0816444,298.986919 59.4768248,298.871603 58.8814188,298.760994 C58.3942684,298.664505 58.0130203,298.485648 57.5494038,298.330325 C57.2952383,298.25031 56.9281105,298.151468 56.6009902,298.160881 C56.2197421,298.163235 55.9067421,298.309144 55.9067421,298.793941 L55.9067421,301.978069 L55.9067421,306.320062 L55.9067421,306.753084 L91.0453667,306.753084 L91.0451105,306.320062 L91.0451105,302.891182 C91.066291,301.001415 89.7813436,298.066746 84.432103,296.457032 C84.432103,296.457032 76.717712,294.082468 74.7738173,292.691618 C73.7642158,291.973836 72.6157647,291.171332 71.4390729,290.985415 C70.7118774,290.870099 69.9799752,290.987768 69.2692534,291.503159",
    id: "Fill-34",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-38",
    transform: "translate(5.706767, 306.015158)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-37"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-36",
    fill: "#417505",
    mask: "url(#mask-8)",
    points: "0.234114286 0.738161654 0.234114286 0.302785714 0.076437594 0.302785714 0.076437594 2.70794361 35.5301594 2.70794361 35.5301594 0.302785714 35.3630692 0.302785714 35.3630692 0.738161654"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.1069263,298.760288 C37.5091669,298.87325 36.8972872,298.988566 36.2854075,299.045047 C35.4852571,299.120356 34.6851068,299.16507 33.8802496,299.160363 C32.4046782,299.143889 30.5290316,299.01916 29.2370241,298.122521 C29.611212,298.416694 30.0607083,298.663799 30.6278737,298.769702 L20.706009,300.487671 C20.706009,300.487671 25.9681744,297.251769 28.0109113,296.425732 C28.0014977,296.33395 28.0109113,296.251581 28.0532722,296.192747 C28.7098662,295.338468 29.0275729,294.319453 28.8934301,293.387514 C28.7875278,292.674438 28.4298135,292.013138 27.7096782,291.502453 C26.9448286,290.949408 26.1611519,290.85998 25.3845353,291.015303 C24.271385,291.250641 23.1723549,292.006077 22.2145278,292.690912 C20.2659263,294.084115 12.5468286,296.456326 12.5468286,296.456326 C7.19758797,298.06604 5.91028722,301.000709 5.9408812,302.890476 L5.9408812,306.319356 L5.9408812,306.752378 L41.0699944,306.752378 L41.0698361,306.319356 L41.0698361,301.977363 L41.0698361,298.795589 C41.0792496,298.244897 40.6674075,298.124874 40.222618,298.160175 C39.9355053,298.183709 39.6389789,298.261371 39.4295278,298.329619 C38.9682647,298.487295 38.5917233,298.663799 38.1069263,298.760288",
    id: "Fill-39",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7069504,300.488377 L30.628815,298.770408 C30.0616496,298.664505 29.6098,298.4174 29.2379654,298.120874 C28.3625068,297.414859 28.0118526,296.426438 28.0118526,296.424084 C25.9667624,297.252475 20.7069504,300.488377 20.7069504,300.488377",
    id: "Fill-41",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4783759,298.769466 L76.3978872,300.487436 C76.3978872,300.487436 71.131015,297.251534 69.092985,296.425496 C69.092985,296.425496 68.4034436,298.428226 66.4783759,298.769466",
    id: "Fill-43",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1754068,202.846027 L52.1314444,202.846027 L54.228309,286.271117 L57.0053015,286.271117 L71.4386023,286.271117 L72.0222414,286.271117 L74.4156323,191.500365 C74.5756624,190.667268 74.6697977,189.808283 74.6697977,188.930471 L74.6697977,183.381192 L48.1754068,183.381192 L48.1754068,202.846027 Z",
    id: "Fill-45",
    fill: "#945D2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6906647,183.380016 L21.6906647,188.929294 C21.6906647,189.993023 21.8224541,191.021452 22.0413188,192.019286 L24.4158827,287.161873 L25.3831233,287.161873 L39.8117173,287.161873 L42.2027549,287.161873 L44.2878526,202.84485 L48.1756421,202.84485 L48.1756421,183.380016 L21.6906647,183.380016 Z",
    id: "Fill-47",
    fill: "#633E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5946421,98.1642361 L39.1198226,97.7759278 C38.2490707,97.893597 37.4159729,98.0206797 36.5946421,98.1642361",
    id: "Fill-49",
    fill: "#865E2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5651286,133.241887 L39.7620609,117.502459 L40.9222789,111.204805 L35.3329932,110.051647 L36.3896624,98.1976541 C27.9551361,99.6779323 22.3658504,102.586714 18.6710383,105.709654 C17.7249782,106.44391 16.8306925,107.239353 16.042309,108.103045 L16.0376023,108.098338 C16.0376023,108.098338 3.51054211,117.690729 0.947707519,184.705677 L1.18539925,184.705677 L6.33930902,184.705677 L12.7828729,184.705677 L13.1923617,184.705677 C13.1923617,184.705677 13.9477977,153.650429 20.3372338,133.359556 L19.8053692,181.034398 L21.6315947,181.034398 L43.5651286,181.034398 L43.5651286,133.241887 Z",
    id: "Fill-51",
    fill: "#8B572A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.2247195,184.706147 L95.2859075,184.706147 C93.7256143,143.882005 88.4728624,124.365395 84.6015466,115.349583 C84.2132383,114.175245 83.5684113,112.654959 82.5070353,110.993471 C81.1185391,108.472997 78.9863737,106.406726 76.5223812,104.716997 C74.4019827,103.159057 71.7732534,101.683486 68.4973436,100.464433 C63.0116068,97.9463128 58.5919526,97.7792226 58.5919526,97.7792226 L58.5048774,97.7792226 L57.3234789,97.7792226 C57.3140654,97.7792226 57.281118,97.7768692 57.281118,97.7768692 L59.8651331,98.193418 L60.9147421,110.049764 L55.3278098,111.205275 L56.4880278,117.500576 L52.6873135,133.242358 L52.6873135,117.500576 L52.6755466,117.500576 L52.6755466,181.067817 L52.6567195,181.067817 L74.8020579,181.265501 L77.7273135,181.289035 L77.0542459,134.626147 C82.3893662,154.253365 83.0483135,184.706147 83.0483135,184.706147 L83.6225391,184.706147 L90.0708098,184.706147 L95.2247195,184.706147 Z",
    id: "Fill-53",
    fill: "#D1833F"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-55",
    fill: "#C29365",
    points: "57.1453278 98.3708632 57.2818241 97.7754571 57.1618015 98.2579008"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8693278,105.539034 C43.6039594,106.588643 46.0655985,106.974598 48.1483429,107.005192 L48.1153955,97.7799286 C51.4124857,97.7681617 54.9002,97.7799286 57.2300496,97.8552368 L57.1618015,98.2576654 L57.2818241,97.7752218 C56.4769669,97.7493346 55.5285534,97.7375677 54.5048316,97.721094 L54.5048316,92.2847782 C50.7370647,92.9743195 48.1577564,92.7013271 48.1577564,92.7013271 C48.1577564,92.7013271 45.5760947,92.9790263 41.8318617,92.2730113 L41.8318617,97.7422744 C40.1892,97.7587481 39.1207639,97.7752218 39.1207639,97.7752218 L39.139591,97.8528835 L40.8693278,105.539034 Z",
    id: "Fill-57",
    fill: "#C8A985"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1613308,98.2583714 L57.2295789,97.8559429 C54.8997293,97.7806346 51.4143684,97.7688677 48.1149248,97.7806346 L48.1478722,107.005898 C51.6261729,107.062379 54.4125789,105.986883 55.4833684,105.513853 L57.1448571,98.3713338 L57.1613308,98.2583714 Z",
    id: "Fill-59",
    fill: "#D2BA9C"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-61",
    fill: "#4D4C4C",
    points: "40.9220436 111.204334 39.7618256 117.501988 43.5648932 133.241417 43.5648932 117.501988 40.8702692 105.53974 39.1381789 97.8535895 39.1193519 97.7759278 36.5941714 98.1642361 36.3941338 98.1948301 36.3894271 98.1995368 35.3327579 110.051176"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-63",
    fill: "#4D4C4C",
    points: "55.4836038 105.513853 52.6877842 117.501988 52.6877842 133.241417 56.4884985 117.501988 55.3282805 111.204334 60.9152128 110.051176 59.8632504 98.1948301 57.2815887 97.7759278 57.1450925 98.3713338"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6753113,181.068052 L52.6753113,117.500811 L52.6870782,117.500811 L55.4828977,105.515029 C54.4121083,105.988059 51.6280556,107.063556 48.1474015,107.004721 C46.0646571,106.97648 43.6053714,106.590526 40.8683865,105.538563 L43.5653639,117.500811 L43.5653639,133.242593 L43.5653639,181.032751 L21.6318301,181.032751 L21.6318301,183.379074 L21.6906647,183.379074 L48.1756421,183.379074 L74.6700331,183.379074 L74.8018226,183.379074 L74.8018226,181.265736 L52.6564842,181.068052 L52.6753113,181.068052 Z",
    id: "Fill-65",
    fill: "#C7BA15"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Kai-Wang",
    fontFamily: "OpenSans-Bold, Open Sans",
    fontSize: 36,
    fontWeight: "bold",
    fill: "#2C2D32"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 219,
    y: 90
  }, "Kai Wang")), /*#__PURE__*/React.createElement("text", {
    id: "WeChat-Expert",
    fontFamily: "OpenSans-Bold, Open Sans",
    fontSize: 26,
    fontWeight: "bold",
    fill: "#2C2D32"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 219,
    y: 177
  }, "WeChat Expert")), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(219.000000, 233.000000)",
    fill: "#2C2D32"
  }, /*#__PURE__*/React.createElement("text", {
    id: "INFO",
    fontFamily: "OpenSans-Bold, Open Sans",
    fontSize: 22,
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 24
  }, "INFO")), /*#__PURE__*/React.createElement("text", {
    id: "Age:-24",
    fontFamily: "OpenSans-Regular, Open Sans",
    fontSize: 18,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 64
  }, "Age: 24")), /*#__PURE__*/React.createElement("text", {
    id: "City:-Atlanta",
    fontFamily: "OpenSans-Regular, Open Sans",
    fontSize: 18,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 148,
    y: 64
  }, "City: Atlanta")), /*#__PURE__*/React.createElement("text", {
    id: "Major:-Graphic-Desig",
    fontFamily: "OpenSans-Regular, Open Sans",
    fontSize: 18,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 93
  }, "Major: Graphic Design"))), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(47.000000, 523.000000)",
    fill: "#2C2D32"
  }, /*#__PURE__*/React.createElement("text", {
    id: "User-Needs",
    fontFamily: "OpenSans-Bold, Open Sans",
    fontSize: 22,
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 24
  }, "User Needs")), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-3",
    transform: "translate(0.000000, 45.000000)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "To-use-WeChat-for-di",
    fontFamily: "OpenSans-Regular, Open Sans",
    fontSize: 18,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 12,
    y: 19
  }, "To use WeChat for dining in the U.S.")), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 3.5,
    cy: 13.5,
    r: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-4",
    transform: "translate(0.000000, 74.000000)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Looking-for-a-good-v",
    fontFamily: "OpenSans-Regular, Open Sans",
    fontSize: 18,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 12,
    y: 19
  }, "Looking for a good variety of restaurants")), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 3.5,
    cy: 13.5,
    r: 3.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy",
    transform: "translate(47.000000, 675.000000)",
    fill: "#2C2D32"
  }, /*#__PURE__*/React.createElement("text", {
    id: "User-Frustrations",
    fontFamily: "OpenSans-Bold, Open Sans",
    fontSize: 22,
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 24
  }, "User Frustrations")), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-3",
    transform: "translate(0.000000, 45.000000)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Placing-orders-withi",
    fontFamily: "OpenSans-Regular, Open Sans",
    fontSize: 18,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 12,
    y: 19
  }, "Placing orders within a WeChat group is not convenient ")), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 3.5,
    cy: 13.5,
    r: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-4",
    transform: "translate(0.000000, 74.000000)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "WeChat-only-offers-l",
    fontFamily: "OpenSans-Regular, Open Sans",
    fontSize: 18,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 12,
    y: 19
  }, "WeChat only offers limited Chinese restaurant options")), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 3.5,
    cy: 13.5,
    r: 3.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(47.000000, 371.000000)",
    fill: "#2C2D32"
  }, /*#__PURE__*/React.createElement("text", {
    id: "User-Features",
    fontFamily: "OpenSans-Bold, Open Sans",
    fontSize: 22,
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 24
  }, "User Features")), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 45.000000)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Got-used-to-an-all-i",
    fontFamily: "OpenSans-Regular, Open Sans",
    fontSize: 18,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 12,
    y: 19
  }, "Got used to an all-in-one experience of WeChat")), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 3.5,
    cy: 13.5,
    r: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-2",
    transform: "translate(0.000000, 74.000000)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Curious-to-try-all-k",
    fontFamily: "OpenSans-Regular, Open Sans",
    fontSize: 18,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 12,
    y: 19
  }, "Curious to try all kinds of food")), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 3.5,
    cy: 13.5,
    r: 3.5
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersona3);
export default __webpack_public_path__ + "static/media/persona3.0c9696d0adf13ff06c0c5fdae0d13815.svg";
export { ForwardRef as ReactComponent };